import * as Quill from "quill";
import {Auth} from "@/js/caller";

//Icons
const icons = Quill.import('ui/icons');
icons['save'] = '<i class="far fa-save"></i>';
icons['correct'] = '<i class="far fa-edit"></i>';

// ToolBar Utils
export const StudentToolbar = [
  ["bold", "italic", "underline", "strike"]
];
export const TeacherToolbar = [
  [{header: [false, 1, 2, 3, 4, 5, 6]}],
  ...StudentToolbar,
  [
    {align: ""},
    {align: "center"},
    {align: "right"},
    {align: "justify"}
  ],
  //["blockquote", "code-block"],
  // list
  //[{list: "ordered"}, {list: "bullet"}, {list: "check"}],
  // outdent/indent
  //[{indent: "-1"}, {indent: "+1"}],
  // dropdown with defaults from theme
  [{color: []}, {background: []}],
  //["link", "image", "video"],
  ["correct"], // create a correction for the selection
  //["save"], // create a Save for the selection
  //["clean"] // remove formatting button
];

export function GetToolBar(condition = true) {
  const isTeacher = Auth.IsTeacher();
  return condition ? ([
    ...(isTeacher ? TeacherToolbar : StudentToolbar),
    ["save"]
  ]) : false;
}